/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type PostApiCampaignsBodyCampaignType =
    (typeof PostApiCampaignsBodyCampaignType)[keyof typeof PostApiCampaignsBodyCampaignType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostApiCampaignsBodyCampaignType = {
    EMAIL: 'EMAIL',
    SMS: 'SMS',
    TRIGGER: 'TRIGGER',
} as const;
